"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const selectors_1 = require("@/store/ducks/systemComponents/selectors");
const systemComponents_1 = require("@/store/ducks/systemComponents");
const index_view_1 = __importDefault(require("./index.view"));
function SystemComponentsPrompt() {
    const formik = (0, formik_1.useFormikContext)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isPromptVisible = (0, react_redux_1.useSelector)(selectors_1.isPromptVisibleSelector);
    const onSaveChanges = () => {
        formik.handleSubmit();
    };
    const onDiscardChanges = react_1.default.useCallback(() => {
        formik.resetForm();
        dispatch((0, systemComponents_1.onHideSavePrompt)());
    }, [systemComponents_1.onHideSavePrompt, formik.resetForm]);
    return isPromptVisible ? (react_1.default.createElement(index_view_1.default, { saveChangesButtonLabel: "Save Changes", discardChangesButtonLabel: "Discard Changes", onSaveChanges: onSaveChanges, shouldShowPrompt: isPromptVisible, isSaveButtonDisabled: !formik.dirty || formik?.values?.systemComponents.length === 1, onDiscardChanges: onDiscardChanges, hasError: !formik.isValid && formik.submitCount > 0 })) : null;
}
exports.default = SystemComponentsPrompt;
